import React from "react";
import Types from "prop-types";
import { withRouter } from "react-router-dom";
import { ARGUS_APM } from "../../apm";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";
import LoadingSpinner from "../LoadingSpinner";
import MotInvitation from "./MotInvitation";
import MotInviteSwitchAccount from "./MotInviteSwitchAccount";
import MotInvitationError from "./MotInvitationError";
import { getUserinfo, validateInvitation } from "../gateway/InvitationGateway";
import Galileo from "../../galileo";

const STORAGE_KEY = "last_invitation_code";
const RESTORE_TOKEN = "restore_last_session";

const VIEWS = {
  LOADING: "loading",
  INVITATION: "invitation",
  WRONG_ACCOUNT: "wrong_account",
  ERROR: "error",
};

class MotInvitationGate extends React.Component {
  constructor(props) {
    super(props);

    const token = this.props.match.params.token;

    if (token !== RESTORE_TOKEN) {
      sessionStorage.setItem(STORAGE_KEY, token);
    }

    this.state = {
      view: VIEWS.LOADING,
      token,
      userinfo: null,
      inviteErrorReason: null,
    };
  }

  async componentDidMount() {
    if (this.state.token === RESTORE_TOKEN) {
      const savedCode = sessionStorage.getItem(STORAGE_KEY);
      if (savedCode) {
        this.props.history.replace(`/invitation/${savedCode}`);
        return;
      }
    }

    await this.checkInvitationOwnership();
  }

  componentDidUpdate(prevProps) {
    const prevToken = prevProps.match.params.token;
    const newToken = this.props.match.params.token;
    if (prevToken !== newToken && prevToken === RESTORE_TOKEN) {
      sessionStorage.setItem(STORAGE_KEY, newToken);
      this.setState({ token: newToken }, () => this.checkInvitationOwnership());
    }
  }

  async checkInvitationOwnership() {
    let data;
    try {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
        request_type: "invitation_userinfo",
      });
      ({ data } = await getUserinfo());
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: "invitation_userinfo",
        request_status: "success",
      });
      this.setState({ userinfo: data });
    } catch (error) {
      ARGUS_APM.captureError(error);
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: "invitation_userinfo",
        request_status: "failed",
      });
      window.location.assign("/logout");
      return;
    }

    try {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
        request_type: "invitation_validate",
      });
      const isOwner = await validateInvitation({
        code: this.state.token,
        userIdentityId: data.identity_id,
        kind: data.kind,
      });
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: "invitation_validate",
        request_status: "success",
      });

      const isV2Enabled = await Galileo.fetchIsMotInvitationV2Enabled();

      if (isV2Enabled) {
        if (isOwner.valid) {
          this.setState({ view: VIEWS.INVITATION });
        } else if (isOwner.reason === "EXPIRED") {
          this.setState({ view: VIEWS.ERROR, inviteErrorReason: isOwner.reason });
        } else if (isOwner.status === "pending") {
          this.setState({ view: VIEWS.WRONG_ACCOUNT });
        } else {
          this.setState({ view: VIEWS.ERROR, inviteErrorReason: isOwner.reason || null });
        }
      } else {
        this.setState({ view: isOwner.valid ? VIEWS.INVITATION : VIEWS.WRONG_ACCOUNT });
      }
    } catch (error) {
      ARGUS_APM.captureError(error);
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: "invitation_validate",
        request_status: "failed",
      });
      this.setState({ view: VIEWS.INVITATION });
    }
  }

  render() {
    const { view, inviteErrorReason } = this.state;

    switch (view) {
      case VIEWS.WRONG_ACCOUNT:
        return <MotInviteSwitchAccount />;
      case VIEWS.ERROR:
        return <MotInvitationError reason={inviteErrorReason} />;
      case VIEWS.INVITATION:
        return <MotInvitation {...this.props} userinfo={this.state.userinfo} />;
      default:
        return <LoadingSpinner />;
    }
  }
}

MotInvitationGate.propTypes = {
  match: Types.object.isRequired,
  history: Types.object.isRequired,
};

export default withRouter(MotInvitationGate);
export const MotInvitationGateUnwrapped = MotInvitationGate;
